/*
 * O texto da barra de busca, antes de virar pedido: qual é o tipo (recibo ou
 * município), como o recibo é normalizado e como "Nome-UF" se separa. É função
 * pura para ser provada sem tela.
 */

/** As 27 unidades da federação. "Nome-XX" com sigla fora desta lista é só texto. */
const SIGLAS_DAS_UFS = new Set([
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
])

/** Menor texto que já vale um pedido de sugestões. */
export const MINIMO_DE_CARACTERES = 2

/** Nenhum nome de município do IBGE tem algarismo; recibo do CAR sempre tem. */
export function temAlgarismo(texto: string): boolean {
  return /\d/.test(texto)
}

/** O recibo como a API o guarda: sem os espaços das pontas e em maiúsculas. */
export function normalizarRecibo(texto: string): string {
  return texto.trim().toUpperCase()
}

/** Para comparar o que a pessoa digitou com um rótulo: sem caixa e sem acento. */
export function semCaixaNemAcento(texto: string): string {
  return texto.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase()
}

export interface ConsultaDeMunicipio {
  texto: string
  uf?: string
}

/**
 * O pedido de sugestões que o texto pede, ou `null` quando ele não pede nenhum:
 * com algarismo é recibo, e com menos de dois caracteres (sem contar os espaços
 * das pontas) é cedo demais. Terminar em `-UF` com sigla válida separa a sigla
 * ("Campos dos Goytacazes-RJ"), que é como a lista mostra os municípios.
 */
export function consultaDeMunicipio(texto: string): ConsultaDeMunicipio | null {
  const aparado = texto.trim()
  if (temAlgarismo(aparado) || aparado.length < MINIMO_DE_CARACTERES) return null

  const separado = /^(.+?)\s*-\s*([A-Za-z]{2})$/.exec(aparado)
  const nome = separado?.[1]?.trim()
  const sigla = separado?.[2]?.toUpperCase()
  if (nome !== undefined && nome.length >= MINIMO_DE_CARACTERES && sigla !== undefined) {
    if (SIGLAS_DAS_UFS.has(sigla)) return { texto: nome, uf: sigla }
  }
  return { texto: aparado }
}
